<template>
    <div :class="['j-gis-map-layout', currentMeasureType]">
        <div class="j-gis-map" :id="mapRandomId" v-bind="$attrs"/>
        <j-gis-coord v-if="showCoordinate" :point="coordinateTarget" />
        <slot name="control" />
        <slot />
    </div>
</template>

<script>
import baseMixins from '../mixins/baseMixins' // 基础地图载入配置[必须]
import layerMixins from '../mixins/layerMixins' // 拓展图层 网格行政区划等[可移除]
import drawMixins from '../mixins/drawMixins' // 绘画功能资源标注[可移除]
import toolMixins from '../mixins/toolMixins' // 工具函数[必须]
import measureMixins from '../mixins/measureMixins' // 测量模块[可移除]
import queryMixins from '../mixins/queryMixins' // 地图查询模块[可移除]
import apiMixins from '../mixins/apiMixins' // 可直接调用的对外方法[必须][可覆盖]
export default {
  name: 'JGisMap',
  mixins: [baseMixins, layerMixins, drawMixins, measureMixins, queryMixins, toolMixins, apiMixins]
}
</script>

<style>
    .j-gis-map-layout {
        position: relative;
        height: 100%;
        width: 100%;
    }
    .j-gis-map-layout.coordinate{
        cursor: cell;
    }
    .j-gis-map-layout .j-gis-map{
        height: 100%;
        width: 100%;
    }
    .j-gis-map-layout .j-gis-map .esri-zoom{
        display: none;
    }
    .esri-view .esri-view-surface--inset-outline:focus::after {
        display: none;
    }
</style>
